module.exports = __webpack_public_path__ + "img/medical2.293eaf24.png";